import { MenuSplitButton, ToggleButton, ToggleButtonGroup } from '@atoms/buttons';
import { Box } from '@atoms/layout';
import { Stack } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { AgenciesListPage, FacilitiesListPage, RequestsListPage } from './subpages';
import { useAgencyEditStore } from '@libs/store/agencies/agencyEditDrawerStore';
import { EditAgencyDrawer } from './drawers/editAgency';

type Props = {
  activeTab: 'requests' | 'agencies' | 'facilities';
};
export function ClientsPageLayout({ activeTab }: Props) {
  const navigate = useNavigate();
  const intl = useIntl();
  const { drawerOpen: agencyEditDrawerOpen, openDrawer } = useAgencyEditStore();

  const loading = false;
  const localizationSubset = 'clients';

  const handleNewAction = () => {
    if (activeTab === 'agencies') {
      handleNewAgency();
    } else {
      handleNewFacility();
    }
  };
  const handleNewFacility = () => {};
  const handleNewAgency = () => {
    openDrawer();
  };

  return (
    <>
      <Stack
        aria-label="ClientsPageLayoutWrapper"
        spacing={2}
        direction={'column'}
        sx={{ height: '100%', width: '100%' }}
      >
        <Stack direction={'row'} spacing={1} aria-label="ClientsPageHeader">
          <ToggleButtonGroup aria-label="ClientsSubPageSwitcher" value={activeTab}>
            <ToggleButton value="requests" size="large" onClick={() => navigate('/clients/requests')}>
              <FormattedMessage id={`${localizationSubset}.subpageMenu.requests`} />
            </ToggleButton>
            <ToggleButton value="agencies" size="large" onClick={() => navigate('/clients/agencies')}>
              <FormattedMessage id={`${localizationSubset}.subpageMenu.agencies`} />
            </ToggleButton>
            <ToggleButton value="facilities" size="large" onClick={() => navigate('/clients/facilities')}>
              <FormattedMessage id={`${localizationSubset}.subpageMenu.facilities`} />
            </ToggleButton>
          </ToggleButtonGroup>
          <Box flex={1} />
          <MenuSplitButton
            disabled={loading}
            onMainClick={handleNewAction}
            label={intl.formatMessage({
              id: `${localizationSubset}.menuButton.${activeTab === 'agencies' ? 'agency' : 'facility'}`,
            })}
            menuItems={[
              {
                label: intl.formatMessage({ id: `${localizationSubset}.menuButton.agency` }),
                onAction: handleNewFacility,
              },
              {
                label: intl.formatMessage({ id: `${localizationSubset}.menuButton.facility` }),
                onAction: handleNewAgency,
              },
            ]}
          />
        </Stack>
        {activeTab === 'requests' && <RequestsListPage localizationSubset={`${localizationSubset}.requests`} />}
        {activeTab === 'agencies' && <AgenciesListPage localizationSubset={`${localizationSubset}.agencies`} />}
        {activeTab === 'facilities' && <FacilitiesListPage localizationSubset={`${localizationSubset}.facilities`} />}
      </Stack>
      {agencyEditDrawerOpen && <EditAgencyDrawer onSaveCall={() => {}} localizationSubset={`${localizationSubset}.drawers.agency`} />}
    </>
  );
}
